import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import CategoryForm from './CategoryForm';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useAttendeeCategoryQuery } from '@/registration/hook/useAttendeeCategoryQuery';
import { useKitchenSink } from '@/app/ProviderKitchenSink';
import QueryContainer from '@/base/QueryContainer/QueryContainer';

const Category: FC = () => {
  const { eventId } = useRegisterRoute();
  const attendeeCategoryQuery = useAttendeeCategoryQuery(eventId);
  const { attendeeCategoryId } = useKitchenSink();

  return (
    <RegisterLayout header={null} showShoppingCart={false}>
      <QueryContainer query={attendeeCategoryQuery}>
        {(attendeeCategoryData) => {
          return (
            <CategoryForm
              attendeeCategoryData={attendeeCategoryData}
              attendeeCategoryId={Number(attendeeCategoryId)}
            />
          );
        }}
      </QueryContainer>
    </RegisterLayout>
  );
};

export default Category;
